// context-aware notification 的全域 holder
//
// antd v6 靜態 notification.xxx() 無法讀取 ConfigProvider 的 context
// (動態主題、CSP nonce),官方建議改用 <App> 的 App.useApp()。
// 但 useApp() 是 hook,只能在元件內使用;本專案有部分呼叫在元件外
// (api.jsx 的 axios 攔截器、模組層級的 openNotification helper 等),
// 這些改用此 holder:實例由進入點的 <NotificationBridge/> 透過
// App.useApp() 注入,呼叫寫法與原本 notification.xxx() 完全相同。

let instance = null

export const setNotificationInstance = (inst) => {
  instance = inst
}

const invoke = (method, arg) => {
  if (!instance) {
    // bridge 尚未掛載(理論上使用者互動前即已就緒)
    return undefined
  }
  return instance[method](arg)
}

export const notification = {
  open: (config) => invoke("open", config),
  info: (config) => invoke("info", config),
  success: (config) => invoke("success", config),
  error: (config) => invoke("error", config),
  warning: (config) => invoke("warning", config),
  warn: (config) => invoke("warning", config),
  destroy: (key) => invoke("destroy", key),
  close: (key) => invoke("destroy", key)
}
